import { createAction, props } from '@ngrx/store';
import { ResponsePio } from '../../shared/interfaces';
import { PioTypes } from '../../shared/enums';


export const getPio = createAction(
    PioTypes.PIO
);

export const getPioSucess = createAction(
    PioTypes.PIO_SUCCESS,
    props<{ response: ResponsePio }>()
);

export const getPioError = createAction(
    PioTypes.PIO_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    PioTypes.CLEAN_STATE
);
